/**
 * 빈 상태·안내 일러스트의 단일 진입점 (컨셉 §5 · graphics-catalog.md).
 *
 * SVG 는 토큰 색(var(--panel) 등)을 쓰므로 <img src> 가 아니라 인라인으로 붙인다.
 * 항상 장식(aria-hidden)이며 "왜 비었고 무엇을 하면 되는지" 문장과 함께 놓는다.
 * 자산 파일은 web-graphic-artist 가 관리한다 — 여기서는 이름만 묶는다.
 */
import emptyResults from '../assets/graphics/illustrations/empty-results.svg?raw';
import emptyRecent from '../assets/graphics/illustrations/empty-recent.svg?raw';
import emptyUpload from '../assets/graphics/illustrations/empty-upload.svg?raw';
import noAccess from '../assets/graphics/illustrations/no-access.svg?raw';
import loginNeeded from '../assets/graphics/illustrations/login-needed.svg?raw';
import notFound from '../assets/graphics/illustrations/not-found.svg?raw';
import errorServer from '../assets/graphics/illustrations/error-server.svg?raw';
import pendingApproval from '../assets/graphics/illustrations/pending-approval.svg?raw';
import emptyTrash from '../assets/graphics/illustrations/empty-trash.svg?raw';

const ART = {
  'empty-results': emptyResults,
  'empty-recent': emptyRecent,
  'empty-upload': emptyUpload,
  'no-access': noAccess,
  'login-needed': loginNeeded,
  'not-found': notFound,
  'error-server': errorServer,
  'pending-approval': pendingApproval,
  /** 빈 휴지통(관리 「휴지통」 빈 상태) — 2026-10-18 그래픽 */
  'empty-trash': emptyTrash,
} as const;

export type IllustrationName = keyof typeof ART;

export default function Illustration({ name, className }: { name: IllustrationName; className?: string }) {
  return (
    <div className={className ? `illus ${className}` : 'illus'} aria-hidden="true"
         dangerouslySetInnerHTML={{ __html: ART[name] }} />
  );
}
